const NewLayout = () => import(/* webpackChunkName: "base" */'@/components/pages/customerHome/Index');
const Catalogue = () => import(/* webpackChunkName: "home" */'@/components/pages/customerHome/catalogue/Index');
// const Knowledge = () => import(/* webpackChunkName: "home" */'@/components/pages/newHome/Knowledge/Index');
const KnowledgeDetail = () => import(/* webpackChunkName: "home" */'@/components/pages/customerHome/knowledge/KnowledgeDetail');
const MybBll = () => import(/* webpackChunkName: "home" */'@/components/pages/customerHome/mybBll/Index');
const NewHome = () => import(/* webpackChunkName: "home" */'@/components/pages/customerHome/newHome/Index');
const Detail = () => import(/* webpackChunkName: "home" */'@/components/pages/customerHome/newHome/Detail');
// const AnnouncementDetail = () => import(/* webpackChunkName: "announcement" */'@/components/pages/announcement/AnnouncementDetail');
// const Announcement = () => import(/* webpackChunkName: "home" */'@/components/pages/announcement/Announcement');
const AnnouncementDetail = () => import(/* webpackChunkName: "home" */'@/components/pages/customerHome/newHome/AnnouncementDetail');
const Announcement = () => import(/* webpackChunkName: "home" */'@/components/pages/customerHome/newHome/Announcement');
const RequestWorkflowDetail = () => import(/* webpackChunkName: "requestManage" */'@/components/pages/customerHome/mybBll/RequestWorkflowDetail');
const EventWorkflowDetail = () => import(/* webpackChunkName: "taskManage" */'@/components/pages/customerHome/mybBll/EventWorkflowDetail');
const EventCreatePage = () => import(/* webpackChunkName: "home" */'@/components/pages/customerHome/mybBll/EventCreatePage');
const KnowledgeSearch = () => import(/* webpackChunkName: "home" */'@/components/pages/customerHome/knowledge/KnowledgeSearch');
const RequestCreatePage = () => import(/* webpackChunkName: "requestManage" */'@/components/pages/customerHome/mybBll/RequestCreatePage');
const Profile = () => import(/* webpackChunkName: "base" */'@/components/pages/user/Profile');
export default [
  {
    path: '/Catalogue',
    meta: {
    },
    component: NewLayout,
    children: [
      {
        path: '',
        name: 'Catalogue',
        meta: {
          // title: '服务目录',
          isCustomerPage: true,
          icon: 'home',
          anchor: true,
          activeMenu: '/catalogue',
          componentName: 'Catalogue',
        },
        component: Catalogue
      },
      {
        path: 'create-request-workflow/:entryId',
        name: 'createMyRequestWorkflow',
        meta: {
          title: '新建请求单据',
          isCustomerPage: true,
          hidden: true,
          activeMenu: '/catalogue',
          componentName: 'RequestCreatePage',
        },
        component: RequestCreatePage
      },
    ]
  },
  {
    path: '/Knowledge',
    meta: {
    },
    component: NewLayout,
    children: [
      {
        path: '',
        name: 'Knowledge',
        meta: {
          // title: '知识库',
          isCustomerPage: true,
          icon: 'knowledge',
          anchor: true,
          activeMenu: '/knowledge',
          componentName: 'knowledge',
        },
        component: KnowledgeSearch
      },
      {
        path: 'knowledge/:id',
        props: true,
        name: 'myCustomerKnowledgeDetail',
        meta: {
          title: '知识详情',
          isCustomerPage: true,
          hidden: true,
          activeMenu: '/home',
          componentName: 'KnowledgeDetail',
          // breadcrumb: [
          //   {
          //     name: '主页',
          //     path: '/home'
          //   },
          //   {
          //     name: '知识详情',
          //     path: '/home/knowledge/:id'
          //   }
          // ]
        },
        component: KnowledgeDetail
      },
      {
        path: 'knowledge-search',
        props: true,
        name: 'myCustomerKnowledgeBench',
        meta: {
          title: '知识检索',
          isCustomerPage: true,
          hidden: true,
          activeMenu: '/knowledge',
          componentName: 'KnowledgeSearch',
          // breadcrumb: [
          //   {
          //     name: '主页',
          //     path: '/home'
          //   },
          //   {
          //     name: '知识检索',
          //     path: '/home/knowledge-search'
          //   }
          // ]
        },
        component: KnowledgeSearch
      },
    ]
  },
  {
    path: '/MybBll',
    meta: {
    },
    component: NewLayout,
    children: [
      {
        path: '',
        name: 'MybBll',
        meta: {
          // title: '我的单据',
          isCustomerPage: true,
          icon: 'mybBll',
          anchor: true,
          activeMenu: '/mybBll',
          componentName: 'mybBll',
        },
        component: MybBll
      },
      {
        path: 'request-task-workflow/:id',
        props: true,
        name: 'myEditRequestWorkflow',
        meta: {
          title: '处理任务',
          isCustomerPage: true,
          hidden: true,
          activeMenu: '/mybBll',
          componentName: 'TaskWorkflowDetail',
        },
        component: RequestWorkflowDetail
      },
      {
        path: 'edit-event-workflow/:id',
        props: true,
        name: 'myEventWorkflowDetail',
        meta: {
          title: '处理任务',
          isCustomerPage: true,
          hidden: true,
          activeMenu: '/mybBll',
          componentName: 'EventWorkflowDetail',
        },
        component: EventWorkflowDetail
      },
      {
        path: 'create-event-workflow',
        props: true,
        name: 'myCustomerEventWorkflowCreate',
        meta: {
          title: '新建请求',
          isCustomerPage: true,
          hidden: true,
          activeMenu: '/mybBll',
          componentName: 'MyEventCreatePage',
        },
        component: EventCreatePage
      },
    ]
  },
  {
    path: '/customerHome',
    component: NewLayout,
    children: [
      {
        path: '',
        name: 'NewHome',
        meta: {
          // title: '首页',
          isCustomerPage: true,
          icon: 'newHome',
          anchor: true,
          activeMenu: '/newHome',
          componentName: 'newHome',
        },
        component: NewHome
      },
      {
        path: '/announcementDetail',
        name: 'MyCustomerSearchAnnouncementDetail',
        meta: {
          title: '公告详情',
          isCustomerPage: true,
          hidden: true,
          activeMenu: '/newHome',
          componentName: 'AnnouncementDetail',
          // breadcrumb: [
          //   {
          //     name: '主页',
          //     path: '/newHome'
          //   },
          //   {
          //     name: '公告列表',
          //     path: '/home/announcement-bench'
          //   }
          // ]
        },
        component: AnnouncementDetail
      },
      {
        path: '/property/asset-detail/:id',
        name: 'propertyAssetDetail',
        meta: {
          isCustomerPage: true,
          hidden: true,
          activeMenu: '/newHome',
          componentName: 'propertyDetail',
          // breadcrumb: [
          //   {
          //     name: '主页',
          //     path: '/newHome'
          //   },
          //   {
          //     name: '公告列表',
          //     path: '/home/announcement-bench'
          //   }
          // ]
        },
        component: Detail
      },
      {
        path: '/announcement',
        name: 'customerSearchAnnouncements',
        meta: {
          title: '公告管理',
          isCustomerPage: true,
          hidden: true,
          activeMenu: '/newHome',
          componentName: 'Announcement',
          // breadcrumb: [
          //   {
          //     name: '主页',
          //     path: '/newHome'
          //   },
          //   {
          //     name: '公告列表',
          //     path: '/home/announcement-bench'
          //   }
          // ]
        },
        component: Announcement
      }
    ]
  },
  {
		path: '/personal',
    name: 'personals',
    component: NewLayout,
    children: [
      {
        path: 'newProfile',
        name: 'myProfile',
        meta: {
          title: '个人信息',
          isCustomerPage: true,
          componentName: 'Profile',
          breadcrumb: [
            {
              name: '个人信息',
              path: '/personal/profile'
            }
          ]
        },
        component: Profile
      }
    ]
	},
];


// WEBPACK FOOTER //
// ./src/router/customerHome.js